/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Type of the booked session
 */
export enum ProfessionalBookingBaseResponseSessionType {
  SINGLE = 'SINGLE',
  GROUP = 'GROUP'
}
